import { onRequest, RequestMethod } from "common/axios/axios";
import { getApiUrl } from "common/axios/getApiUrl";

export type ViewType = 'REALTIME' | 'SAFE_RETURN';

export interface ViewerEntry {
    userNo: number;
    nickname: string | null;
    profileImgPath: string | null;
    viewType: ViewType;
    viewCount: number;
    firstViewedAt: string;
    lastViewedAt: string;
}

export interface MeetingGroup {
    meetingId: string;
    meetingName: string | null;
    meetingType: 'DAY' | 'TRAVEL';
    scheduleStartAt: string | null;
    scheduleEndAt: string | null;
    viewDate: string; // 'YYYY-MM-DD'
    viewers: ViewerEntry[];
}

export interface LocationViewStats {
    yearMonth: string | null;
    totalViews: number;
    uniqueViewers: number;
    byGroup: MeetingGroup[];
    availableMonths: string[];
}

export class LocationViewLogRepository {

    /**
     * 위치 확인 로그 기록 — viewer (= 본인) 가 target 들의 위치를 확인했음을 모임 단위로 기록.
     * (viewer, target, meeting, view_date, view_type) 당 1행, 중복 호출은 view_count + lastViewedAt 만 갱신.
     */
    static onRecordViews = (
        meetingId: string,
        targetUserNos: number[],
        viewType: ViewType = 'REALTIME',
    ) => {
        return onRequest({
            url: `${getApiUrl('meetingDetail')}/${meetingId}/location/view-log`,
            method: RequestMethod.POST,
            params: { targetUserNos, viewType },
        });
    };

    /**
     * 내 위치 확인 이력 통계 — 설정 > 내 위치 확인 이력 화면용.
     * yearMonth 누락 시 서버가 가장 최신 월로 fallback.
     */
    static onGetMyStats = (yearMonth?: string) => {
        const qs = yearMonth ? `?yearMonth=${encodeURIComponent(yearMonth)}` : '';
        return onRequest({
            url: `${getApiUrl('myLocationViewStats')}${qs}`,
            method: RequestMethod.GET,
        });
    };
}
